module.exports = __webpack_public_path__ + "img/final-on.ce04ae3e.svg";